import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZerplyComponent } from './simple-icons-zerply.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZerplyComponent ],
    exports:      [ SimpleIconsZerplyComponent ],
    bootstrap:    []
})
export class SimpleIconsZerplyModule {}
